import * as React from 'react';
import styles from './search-tile.scss';

interface SearchTileComponentProps {
  componentId?: string;
  footer?: JSX.Element;
  header?: JSX.Element;
  deleted?: boolean;
}
export const SearchTile: React.FC<SearchTileComponentProps> = ({
  componentId, header, children, footer, deleted
}) => (
    <article
      id={componentId}
      className={`${styles.searchTile} ${deleted ? styles.searchTileDeleted : ''}`}>
      {header && <header>
        {header}
      </header>}
      <main>
        {children}
      </main>
      {footer && <footer>
        {footer}
      </footer>}
    </article>
  );
